import { Home, Paintbrush, Wrench, Box, Droplet, Layers, Brush, Settings, Hammer } from "lucide-react";

export const services = [
  {
    icon: Home,
    title: "Innenausbau",
    description: "Kompletter Innenausbau von der Planung bis zur Fertigstellung",
    value: "innenausbau"
  },
  {
    icon: Layers,
    title: "Fassadenarbeiten",
    description: "Fassadensanierung, Dämmung und Anstrich für ein neues Erscheinungsbild",
    value: "fassade"
  },
  {
    icon: Wrench,
    title: "Renovierung & Sanierung",
    description: "Modernisierung und fachgerechte Sanierung von Bestandsimmobilien",
    value: "renovierung"
  },
  {
    icon: Box,
    title: "Trockenbau",
    description: "Präzise Trockenbauarbeiten für Wände, Decken und Raumgestaltung",
    value: "trockenbau"
  },
  {
    icon: Droplet,
    title: "Fliesenarbeiten",
    description: "Professionelle Fliesenverlegung für Bad, Küche und Wohnräume",
    value: "fliesen"
  },
  {
    icon: Hammer,
    title: "Verputzer / Putzarbeiten",
    description: "Innen- und Außenputz, Glättputz, Struktur- und Sanierputz vom Fachbetrieb",
    value: "verputzer"
  },
  {
    icon: Brush,
    title: "Bodenbeschichtungen",
    description: "Hochwertige Bodenbeschichtungen für jeden Einsatzbereich",
    value: "boden"
  },
  {
    icon: Paintbrush,
    title: "Malerarbeiten",
    description: "Perfekte Oberflächen und strahlende Farben – innen wie außen",
    value: "malerarbeiten"
  },
  {
    icon: Settings,
    title: "Komplettlösungen",
    description: "Alles aus einer Hand – von der Beratung bis zur Abnahme",
    value: "komplett"
  }
];
